export const defaultStrings = {
    title: 'Cookies & Privacy',
    description: "We use essential cookies. With your consent, we'll use analytics and marketing.",
    buttons: {
        acceptAll: 'Accept all',
        rejectAll: 'Reject all',
        manage: 'Manage',
        save: 'Save',
        cancel: 'Cancel',
    },
    policy: { linkText: 'Cookie policy', href: '' },
    categories: {
        essential: {
            label: 'Essential',
            description: 'Required for the website to function. Cannot be disabled.',
            cookies: 'Session, security tokens',
        },
        analytics: {
            label: 'Analytics',
            description: 'Help us understand how visitors use our site.',
            cookies: 'None currently',
        },
        marketing: {
            label: 'Marketing',
            description: 'Used for targeted advertising and tracking.',
            cookies: 'None currently',
        },
        functional: {
            label: 'Functional',
            description: 'Enable enhanced features like preferences and live chat.',
            cookies: 'None currently',
        },
    },
};
//# sourceMappingURL=strings.js.map